// #region Imports
import { defineComponent } from 'vue';
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-search-box__custom',
    // #endregion
    // #region Props
    props: {
        items: {
            type: Array,
            required: true,
        },
        selectedItem: {
            type: Object,
            default: null,
        },
        idField: {
            type: String,
            default: 'id',
        },
        highlightedIndex: {
            type: Number,
            default: -1,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isLoadingMore: {
            type: Boolean,
            default: false,
        },
    },
    // #endregion
    emits: {
        select: (_item) => true,
    },
    // #region Methods
    methods: {
        // #region Helper
        isSelected(item) {
            return !!this.selectedItem && this.selectedItem[this.idField] === item[this.idField];
        },
        // #endregion
    },
    // #endregion
});
// #endregion
